<template>

    <input-child
        v-bind="getInputProps({
            icon: loading && iconSide === 'append' ? iconLoading : icon,
            iconRight: loading && iconSide !== 'append' ? iconLoading : iconRight,

            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onClick: onInputFocus,
            onKeyDown: onInputWrite,
            inputClass: (dropdownShow ? 'show ' : '') + inputClass,
            id: getUniqueId('inputAutocomplete')
        })"

        v-model="inputValue"

        ref="input"
    >
        <template #beforeInput>
            <slot name="beforeInput"></slot>
        </template>
        <template #afterInput>
            <slot name="afterInput"></slot>
        </template>
        <template #inputContainer>
            <div class="dropdown-menu w-100 shadow p-0 autocomplete-menu" :class="{'show': dropdownShow}" :aria-labelledby="getUniqueId('inputAutocomplete')">

                <div class="list-group">
                    <template v-for="item in autocompleteList">
                        <div class="list-group-item list-group-item-action cursor-pointer" @mousedown.prevent="onSelectItem(item, $event)">
                            {{ item.text }}
                        </div>
                    </template>
                </div>

            </div>
        </template>

        <template #hidden>
            <slot
                    name="hidden"
                    v-bind="{ autocompleteList, selected, dropdownShow }"
            >
            </slot>
        </template>
        <template #next>
            <slot
                    name="next"
                    v-bind="{ autocompleteList, selected, dropdownShow }"
            >
            </slot>
        </template>
        <template #prev>
            <slot
                    name="prev"
                    v-bind="{ autocompleteList, selected, dropdownShow }"
            >
            </slot>
        </template>
    </input-child>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinAjax from './mixinAjax';
    import mixinInput from './mixinInput';

    import Input from './Input'

    const { props } = Input;

    export default {
        mixins: [ mixinCommon, mixinAjax, mixinInput ],

        components: {
            'input-child': Input
        },
        props: {
            ...props,

            iconLoading: {
                type: String,
                default: 'fa fa-spinner fa-pulse text-primary'
            },

            strictSelection: false,
            autocompleteOnVoid: {
                type: [String, Number, Boolean],
                default: true
            },

            autocompleteHandler: {
                type: Function,
                default: null
            },

            disableAjax: {
                type: [Boolean, String, Number],
                default: null
            },

            onSelect: {
                type: Function,
                default: () => {}
            },

            defaultSelected: {
                type: Object,
                default: () => null
            },

            defaultAutocompleteList: {
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                timer: null,
                dropdownShow: false,
                selected: this.defaultSelected,
                autocompleteList: this.defaultAutocompleteList
            };
        },
        computed: {
            firstAutocomplete() {
                if( !this.autocompleteList.length ) {
                    return false;
                }

                return this.autocompleteList[0];
            }
        },
        watch: {
            ajaxLoading( isLoading ) {
                this.loading = !!+isLoading;
            },

            inputValue( inputValue ) {
                this.$emit('input', inputValue);
            },
            defaultAutocompleteList: {
                handler( defaultAutocompleteList ) {
                    this.autocompleteList = defaultAutocompleteList;
                },
                deep: true
            },
            selected: {
                handler( item = null ) {
                    const { text = '' } = item || {};
                    this.inputValue = text;
                    this.onSelect( item );
                },
                deep: true
            }
        },
        mounted() {

        },
        methods: {
            onSelectItem( item, evt ) {
                evt.preventDefault();
                this.selectItem(item);
                this.dropdownShow = false;
            },

            selectItem( item ) {
                this.selected = item;
                this.inputValue = item ? item.text : '';
            },

            matchToAutocomplete( pos = null ) {
                if( !!this.autocompleteList.length ) {
                    return false;
                }
                if( pos >= 0 && this.autocompleteList.length < pos+1 ) {
                    return false;
                }
                const list = this.autocompleteList[pos] ? [this.autocompleteList[pos]] : this.autocompleteList;
                for( let item of list ) {
                    if( this.inputValue.toLowerCase().trim() === item.text.toLowerCase().trim() ) {
                        return item;
                    }
                }
                return false;
            },
            matchToSelected() {
                if( !this.selected ) {
                    return false;
                }
                return this.inputValue.toLowerCase().trim() === this.selected.text.toLowerCase().trim();
            },

            async fetchAutocomplete() {
                if( !!+this.disableAjax ) {
                    return;
                }
                if( typeof this.autocompleteHandler === 'function' ) {
                    return await this.autocompleteHandler();
                }
                await this.callAjax({ query: this.inputValue });
                if( this.isBlur() ) {
                    return this.resetAutocomplete();
                }
                return this.autocompleteList = this.responseData || [];
            },

            async onInputWrite( evt ) {
                if( this.timer ) clearTimeout( this.timer );
                switch( evt.which ) {
                    case 13 :
                        evt.preventDefault();
                        await this.fetchAutocomplete();
                        return this.blur();
                    break;
                    default :
                    break;
                }
                this.timer = setTimeout(async () => {
                    this.dropdownShow = this.isFocus();

                    await this.fetchAutocomplete();
                }, 400);
            },

            async onInputFocus( evt ) {
                this.select();
                const isValidLength = this.length || !!+this.autocompleteOnVoid;
                if( isValidLength ) {
                    await this.fetchAutocomplete();
                    this.dropdownShow = isValidLength && this.isFocus();
                }
            },

            onInputBlur( evt ) {
                this.dropdownShow = false;
                if( !this.matchToSelected() && this.length ) {
                    const itemMatch = this.matchToAutocomplete();
                    if( this.strictSelection ) {
                        this.selectItem( itemMatch || this.firstAutocomplete || this.selected );
                    }
                    else {
                        this.selectItem( itemMatch || { text: this.inputValue });
                    }
                }
                if(!this.matchToSelected() && this.length == 0){
                    this.selectItem(null);
                }
                this.resetAutocomplete();
            },

            resetAutocomplete() {
                return this.autocompleteList = this.defaultAutocompleteList || [];
            },


            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( Input, overrideProps );
            }
        }
    };
</script>
